import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { MisconfigurationsAppWebComponentSchema } from '../types';

export class MisconfigurationsAppBaseDataProvider extends BaseWebComponentDataProvider {
  async getDataForView(): Promise<MisconfigurationsAppWebComponentSchema> {
    throw new Error('Not implemented');
  }
}
